import MuiPopper from "@mui/material/Popper";
import styled from "styled-components";

export const Popper = styled(MuiPopper)`
  z-index: 100;
`;
